export default class VariabiliGlobali {
    static doveMiTrovo = "paginaPrincipale";
    static porta = '3000';
    static indirizzoIP = 'http://95.110.144.5:';

}
